import { IconButton, Tooltip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";
import {
  Datagrid,
  DeleteWithConfirmButton,
  List,
  RaRecord,
  TextField,
  useRecordContext,
  useRefresh,
} from "react-admin";
import { ShowListTotal } from "../unit/ShowListTotal";
import { downloadCSV } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomEditLinkIcon from "../unit/CustomEditLinkIcon";
import CustomEditRemoveIcon from "../unit/CustomEditRemoveIcon";
import formatDate from "../unit/formatDate";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import SwitchIcon from "../unit/svgIcon/SwitchIcon";
import SwitchOnIcon from "../unit/svgIcon/SwitchOnIcon";
import useNotify from "../unit/useNotify";
import BankListActions from "./BankListActions";
import BankListAside from "../bankers/BankListAside";
import PostPagination from "../unit/PostPagination";
import { hmLightTheme } from "../themes/hmTheme";
import HmLoading from "../unit/HmLoading";
import NoResults from "../unit/NoResults";
const DeleteWithConfirmButtonStyled = styled(DeleteWithConfirmButton)({});

function getProbationStatusText(iProbation: number, sStatus: string) {
  if (sStatus !== "ENABLED") {
    return "Disabled";
  }
  if (sStatus === "ENABLED" && iProbation === 0) {
    return "Normal";
  }
  return iProbation === 1 ? "Yes" : "No";
}
const bankTypeExporter = (records: any) => {
  let data = [];
  let title = {};

  data = records.map((record: any) => {
    const { id } = record;
    return {
      id: id,
      sBankName: `"${record.sBankName}"`,
      sBussinessClassification: record.sBussinessClassification,
      dwolla_customer_status: record.dwolla_customer_status,
      productnum: record.productnum,
      banker_mobilephone: record.banker_mobilephone,
      banker_email: record.banker_email,
      banker_name: record.banker_name,
      iProbation: getProbationStatusText(record.iProbation, record.sStatus),
      // created_at: formatDate(record.created_at, "YYYY-MM-DD"),
    };
  });
  title = {
    id: "Institution ID",
    sBankName: "Institution Name",
    sBussinessClassification: "Industry",
    dwolla_customer_status: "ACH Account",
    productnum: "Num of Products",
    banker_mobilephone: "Admin Phone Number",
    banker_email: "Admin Email Address",
    banker_name: "Admin Name",
    iProbation: "Probation",
    // created_at: "Created Time",
  };
  return {
    title: title,
    data: data,
  };
};
const CustomExporter = (records: any) => {
  const filterData = bankTypeExporter(records);

  let csvTitle = filterData.title;
  let data = filterData.data;
  const csvData = [{ ...csvTitle }, ...data];
  const csvDataStr = csvData.map((row) => Object.values(row).join(","));
  downloadCSV(csvDataStr.join("\n"), "Institution");
};
const CustomBankNameField = ({ ...props }) => {
  let record = useRecordContext();
  if (!record) return null;
  return <Typography>{record?.sBankName}</Typography>;
};

const ProbationField = ({ ...props }) => {
  const record = useRecordContext();
  if (!record) return null;
  if (record?.sStatus != "ENABLED") {
    return <Typography sx={{ color: "grey" }}>Disabled</Typography>;
  }
  if (record?.sStatus == "ENABLED" && record?.iProbation == 0) {
    return <Typography>Normal</Typography>;
  }
  return <Typography>{record?.iProbation == 1 ? "Yes" : "No"}</Typography>;
};
const BankList = () => {
  const authrole = localStorage.getItem("authrole");

  const refresh = useRefresh();
  const [editRecord, setEditRecord] = React.useState<RaRecord | null>(null);
  const [open, setOpen] = React.useState(false);
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [record, setRecord] = React.useState<{ total: number } | null>(null);
  const handleClose = () => {
    setOpen(false);
    setEditRecord(null);
    refresh();
  };

  const handleCancel = () => {
    setEditRecord(null);
  };

  const handleButtonClick = (record: any) => {
    setOpen(true);
    setEditRecord(record);
  };

  const CustomButton = ({ onClick }) => {
    const record = useRecordContext();

    const handleClick = () => {
      onClick(record);
    };

    const handleRemove = () => {
      var reqUrl = `banks/actions/delete`;
      sendRequest(reqUrl, { id: record?.id }).then((response) => {
        if (response && response.code == "200") {
          successNotify("Data deleted successfully");
          refresh();
          handleClose();
        } else {
          errorNotify("Data not deleted");
        }
      });
      setOpen(false);
      setEditRecord(null);
    };

    const handleChangeStatus = () => {
      let newStatus = record?.sStatus == "ENABLED" ? "DISABLED" : "ENABLED"; // Toggle status

      // Update the record status in the database
      var reqUrl = "banks/actions/changeStatus";
      var response = sendRequest(reqUrl, {
        id: record?.id,
        data: {
          status: newStatus,
        },
      });
      response
        .then((res) => {
          if (res.code == 200) {
            successNotify("Status changed successfully");
            refresh();
          } else {
            errorNotify("Failed to change status");
          }
        })
        .catch((error) => {
          errorNotify("Error changing status: " + error.message);
        });
    };

    return (
      <>
        <CustomEditLinkIcon
          to={"/banks/" + record?.id}
          label="Edit institution settings"
        />
        {authrole == "admin" && (
          <>
            <Tooltip
              title={
                `` +
                (record?.sStatus == "ENABLED" ? "Deactivate" : "Activate") +
                ` institution`
              }
              placement="left"
            >
              <IconButton
                size="small"
                onClick={handleChangeStatus}
                sx={{ marginLeft: "5px", p: 1 }}
              >
                {record?.sStatus == "ENABLED" ? (
                  <SwitchOnIcon />
                ) : (
                  <SwitchIcon />
                )}
              </IconButton>
            </Tooltip>
            <CustomEditRemoveIcon onClick={() => handleRemove()} />
          </>
        )}
      </>
    );
  };
  const CustomRowStyle = (record: any) => {
    if (!record) return {};

    if (record?.sStatus == "ENABLED") {
      return {
        backgroundColor: "#fff",
        "&.MuiTableRow-hover:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      };
    } else {
      return {
        backgroundColor: "#f5f5f5",
        "& td.MuiTableCell-root": {
          color: "gray",
        },
        "& td.MuiTableCell-root span": {
          color: "gray",
        },
        "& td.MuiTableCell-root a": {
          color: "gray",
        },
        "& td.MuiTableCell-root p": {
          color: "gray",
        },
      };
    }
  };
  return (
    <>
      <List
        filters={[]}
        sort={{ field: "created_at", order: "DESC" }}
        exporter={CustomExporter}
        actions={<BankListActions />}
        aside={<BankListAside selected="banks" />}
        pagination={<PostPagination />}
        perPage={25}
        sx={{
          width: "100%",
          borderRadius: "0px",
          "& .MuiCard-root": {
            borderRadius: "0px",
          },
          "& .RaList-actions form": {
            flex: "0 1 350%",
          },
          "& .RaList-actions form .filter-field .MuiInputBase-input": {
            width: "230px",
          },
          "& .RaList-actions .RaFilterForm-filterFormInput:first-child .MuiInputBase-root::before":
            {
              display: "none",
            },
          "& .RaList-actions .filter-field:first-child .MuiFormControl-root": {
            marginLeft: 0,
          },
        }}
        empty={
          <Typography className="no-results">
            <NoResults />
          </Typography>
        }
        emptyWhileLoading={false}
        loading={<HmLoading />}
      >
        <Datagrid
          optimized
          rowClick={false}
          rowSx={CustomRowStyle}
          id="table-banks"
          className="hm-list-datagrid"
          sx={{
            ".MuiTableCell-root": {
              padding: "6px",
            },
            ".RaDatagrid-headerCell:first-child": {
              borderTopLeftRadius: "0px",
            },
            ".RaDatagrid-headerCell:last-child": {
              borderTopRightRadius: "0px",
            },
            "& .column-groups": {
              md: { display: "none" },
              lg: { display: "table-cell" },
            },
            "& .Mui-active": {
              color: "gray",
            },

            "& .MuiTableSortLabel-root": {
              padding: "5px",
            },
            "& .RaDatagrid-headerCell": {
              color: "gray",
              fontSize: "1rem",
              backgroundColor: "#edf4fb",
              wordWrap: "break-word",
            },
            "& .MuiTableCell-paddingCheckbox": {
              display: "none",
            },

            "& .MuiTableCell-root.column-id": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              textAlign: "center",
            },
            "& .MuiTableCell-root.column-iProbation": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              textAlign: "center",
            },

            "& .MuiTableCell-root.column-sBankName": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            },
            "& .MuiTableCell-root.column-sBussinessClassification": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            },
            "& .MuiTableCell-root.column-banker_email": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            },
            "& .MuiTableCell-root.column-banker_name": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            },
            "& .MuiTableCell-root.column-dwolla_customer_status": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            },
            "& .MuiTableCell-root.column-action": {
              minWidth: "200px",
              width: "200px",
              maxWidth: "200px",
              textAlign: "center",
              wordBreak: "break-all",
            },
            // banker_mobilephone width 120px
            "& .MuiTableCell-root.column-banker_mobilephone": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdPhoneWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdPhoneWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdPhoneWidth,
              textAlign: "left",
              wordBreak: "break-all",
            },
            "& .MuiTableCell-root.column-banker_productnum": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            },
          }}
        >
          <TextField
            source="id"
            label="Institution ID"
            cellClassName="numericText"
          />
          {/* <BankReferenceField /> */}
          {/* <TextField source="sBankName" label="Institution Name" /> */}
          <CustomBankNameField source="sBankName" label="Institution Name" />
          <TextField source="sBussinessClassification" label="Industry" />
          <TextField source="dwolla_customer_status" label="ACH Account" />
          <TextField
            source="productnum"
            label="Num of Products"
            cellClassName="numericText"
          />
          <TextField
            source="banker_mobilephone"
            label="Admin Phone Number"
            cellClassName="numericText"
          />
          <TextField source="banker_email" label="Admin Email Address" />
          <TextField source="banker_name" label="Admin Name" />
          {/* <TextField source="sStatus" label="Status" /> */}
          {/* <CustomDateField source="created_at" cellClassName="publishedAt" /> */}
          {/* <DeleteWithConfirmButtonStyled
          confirmContent="You will not be able to recover this record. Are you sure?"
          confirmColor="warning"
          label=""
        /> */}
          <ProbationField
            label="Probation"
            source="iProbation"
            sortable={false}
          />

          <CustomButton
            label="Action"
            source="action"
            onClick={handleButtonClick}
            sortable={false}
          />
        </Datagrid>
        {/* <ShowListTotal /> */}
      </List>
      {/* <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            let form = document.querySelector(".banker_edit_dialog_form form");
            let formData = new FormData(form as HTMLFormElement);
            let formJson = Object.fromEntries(formData.entries());

            interface SaveFormJson {
              bank?: string;
              sFname?: string;
              sLname?: string;
            }

            let saveFormJson: SaveFormJson = {};
            saveFormJson.bank = formJson?.bank as string | undefined;
            saveFormJson.sFname = formJson?.sFname as string | undefined;
            saveFormJson.sLname = formJson?.sLname as string | undefined;
            console.log("banker formJson===>", saveFormJson);

            const reqUrl = `banks/actions/edit`;
            const response = await sendRequest(reqUrl, {
              id: editRecord?.id,
              data: formJson,
            });
            if (response && response.code == "200") {
              successNotify("Data saved successfully");
              handleClose();
            } else {
              errorNotify("Data not saved : " + response.message);
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            mb: 2,
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          Member Edit Record #{editRecord?.id}
          <IconButton
            style={{ position: "absolute", right: "10px", top: "10px" }}
            onClick={handleClose}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ height: "500px" }}>
          {editRecord && (
            <BankEdit id={editRecord.id} basePath="/banks" resource="banks" />
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonSubmit />
        </DialogActions>
      </Dialog> */}
    </>
  );
};

export default BankList;
